import React, { useState, useContext } from "react";

import { ModalContainer } from "./styled";

import Button from "components/Form/Button";
import SuccessToast from "components/Toasts/Success";
import { Update } from "services/campaigns";
import { CoreContext } from "context/CoreContext";

export default function ModalRestartCampaign({ closeable, campaign, reload }) {
  const { user } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);

  const finishCampaign = async () => {
    setLoading(true);

    await Update(
      { data: { status: "progress", label: "Andamento", triggeredBy: user?.id } },
      campaign.id
    );

    SuccessToast({ message: `${campaign?.title} em andamento` });

    setLoading(false);

    reload();

    closeable();
  };

  return (
    <>
      <ModalContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            width: "480px",
            height: "275px",
            background: "rgba(255, 255, 255, 1)",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <img
            src="/icons/close.svg"
            width={"10px"}
            height={"10px"}
            style={{ alignSelf: "end", cursor: "pointer" }}
            onClick={closeable}
          />

          <img
            src="/icons/warning-blue.svg"
            width={"64px"}
            height={"64px"}
            style={{ marginTop: "22px" }}
          />
          <p style={{ margin: 0 }}>
            Deseja reiniciar a campanha {campaign?.title}?
          </p>
          <div style={{ display: "flex", gap: "8px" }}>
            <Button outline primary onClick={closeable} minWidth={"136px"}>
              CANCELAR
            </Button>
            <Button
              primary
              onClick={finishCampaign}
              loading={loading}
              minWidth={"136px"}
            >
              REINICIAR
            </Button>
          </div>
        </div>
      </ModalContainer>
    </>
  );
}
